/* Screenshelf 2026: phone and tablet helpers */
(function(){
  'use strict';
  var mq=window.matchMedia('(max-width:999px)');

  /* Collection and search filters: fold into a "Filter" bar on phone and tablet */
  function setupFilters(){
    document.querySelectorAll('.ss-filters').forEach(function(box){
      if(box.__ss)return;box.__ss=1;
      var head=box.querySelector('.ss-filters__head h2');if(!head)return;
      var active=box.querySelectorAll('input[type=checkbox]:checked').length;
      box.querySelectorAll('input[type=number]').forEach(function(i){if(i.value)active++;});
      if(active){var c=document.createElement('span');c.className='ss-filters__count';c.textContent=active;head.appendChild(c);}
      head.setAttribute('role','button');head.setAttribute('tabindex','0');
      function sync(){
        if(mq.matches){box.setAttribute('data-ss-collapsible','');head.setAttribute('aria-expanded',box.classList.contains('is-open')?'true':'false');}
        else{box.removeAttribute('data-ss-collapsible');head.removeAttribute('aria-expanded');}
      }
      function toggle(){if(!mq.matches)return;box.classList.toggle('is-open');sync();}
      head.addEventListener('click',toggle);
      head.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
      if(mq.addEventListener)mq.addEventListener('change',sync);else if(mq.addListener)mq.addListener(sync);
      sync();
    });
  }


  /* Product page on phone: sticky "Add to cart" bar once the main button has scrolled off screen.
     It presses the real button, so quantity, variant and the trade (BSS) pricing all stay the same. */
  function setupSticky(){
    var form=document.querySelector('.ss-pdp #ss-product-form');if(!form)return;
    var btn=form.querySelector('button[type=submit]');if(!btn||!('IntersectionObserver' in window))return;
    var pm=window.matchMedia('(max-width:767px)');
    var bar=document.createElement('div');bar.className='ss-sticky';bar.setAttribute('aria-hidden','true');
    var img=document.querySelector('.ss-pdp .ss-gallery__main img');
    var t=document.querySelector('.ss-pdp .ss-buybox__title');
    bar.innerHTML=(img?'<img class="ss-sticky__img" alt="" src="'+(img.currentSrc||img.src)+'">':'')+'<span class="ss-sticky__name"></span><button type="button" class="ss-sticky__btn" tabindex="-1">Add to cart</button>';
    bar.querySelector('.ss-sticky__name').textContent=t?t.textContent.trim():'';
    document.body.appendChild(bar);
    var past=false;
    function show(){var on=pm.matches&&past&&!btn.disabled;bar.classList.toggle('is-on',on);}
    new IntersectionObserver(function(es){var e=es[0];past=!e.isIntersecting&&e.boundingClientRect.top<0;show();}).observe(btn);
    bar.querySelector('.ss-sticky__btn').addEventListener('click',function(){btn.click();});
    var sel=form.querySelector('[data-ss-variant-select]');if(sel)sel.addEventListener('change',function(){setTimeout(show,50);});
  }


  /* Product page on phone: delivery list folds under the countdown, long descriptions fold, empty lines removed */
  function setupPdp(){
    var pdp=document.querySelector('.ss-pdp');if(!pdp)return;
    var pm=window.matchMedia('(max-width:767px)');
    pdp.querySelectorAll('.ss-desc p').forEach(function(p){if(!p.textContent.replace(/ /g,' ').trim()&&!p.querySelector('img,iframe,video'))p.remove();});
    /* Rating line: short review count on phone so it fits on one line */
    var cnt=pdp.querySelector('[data-ss-pdp-rating] [data-ss-count]');
    if(cnt&&window.MutationObserver){
      var full=cnt.textContent;
      function shortCount(){
        var tx=cnt.textContent;if(!/based on/i.test(tx)&&tx===cnt.__short)return;
        if(/based on/i.test(tx))full=tx;
        var m=full.match(/([\d,.]+)\s*reviews/i);
        var want=pm.matches&&m?('· '+m[1]+' reviews'):full;
        if(tx!==want){cnt.__short=want;cnt.textContent=want;}
      }
      new MutationObserver(shortCount).observe(cnt,{childList:true,characterData:true,subtree:true});
      shortCount();if(pm.addEventListener)pm.addEventListener('change',shortCount);
    }
    var box=pdp.querySelector('.ss-shipbox'),strip=box&&box.querySelector('.ss-shipbox__strip');
    if(box&&strip&&box.querySelector('.ss-shipbox__cols')){
      var b=document.createElement('button');b.type='button';b.className='ss-shipbox__more';b.textContent='Delivery options and cut-off times';b.setAttribute('aria-expanded','false');
      strip.insertAdjacentElement('afterend',b);
      b.addEventListener('click',function(){var o=box.classList.toggle('is-open');b.setAttribute('aria-expanded',o?'true':'false');});
      function syncB(){b.hidden=!pm.matches;}syncB();if(pm.addEventListener)pm.addEventListener('change',syncB);
    }
    var d=pdp.querySelector('.ss-desc');
    if(d){
      var more=document.createElement('button');more.type='button';more.className='ss-desc__more';more.textContent='Read more';more.hidden=true;
      d.insertAdjacentElement('afterend',more);
      var open=false;
      function fold(){
        if(!pm.matches){d.classList.remove('is-folded');more.hidden=true;return;}
        if(open){d.classList.remove('is-folded');more.hidden=false;more.textContent='Show less';return;}
        d.classList.remove('is-folded');var tall=d.scrollHeight>230;d.classList.toggle('is-folded',tall);more.hidden=!tall;more.textContent='Read more';
      }
      more.addEventListener('click',function(){open=!open;fold();});
      fold();if(pm.addEventListener)pm.addEventListener('change',fold);
    }
  }

  function init(){setupFilters();setupSticky();setupPdp();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* Image protection (2 Nov 2026): no right-click "Save image", no dragging, no iOS long-press save on images.
   Text, SKUs and links stay selectable and copyable on purpose. */
(function(){
  function isImg(t){return !!(t&&t.closest&&t.closest('img,picture,video'));}
  document.addEventListener('contextmenu',function(e){if(isImg(e.target))e.preventDefault();},true);
  document.addEventListener('dragstart',function(e){if(e.target&&e.target.tagName==='IMG')e.preventDefault();},true);
  var s=document.createElement('style');
  s.textContent='img{-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none}';
  document.head.appendChild(s);
})();
